<template>
  <b-modal
    id="vimeo-url-modal"
    :title="trans('vimeo_url')"
    :ok-title="trans('save')"
    :cancel-title="trans('cancel')"
    @show="onShow"
  >
    <b-row>
      <b-col class="mt-3">
        <p>{{ trans('vimeo_url_about') }}</p>
        <b-form-group :label="`${trans('label')} (${trans('optional').toLowerCase()})`">
          <b-form-input type="text" v-model="name" :disabled="busy" />
        </b-form-group>
        <b-form-group :label="`${trans('email')} (${trans('optional').toLowerCase()})`">
          <b-form-input type="email" v-model="email" :disabled="busy" />
        </b-form-group>
        <b-form-group :label="`${trans('mobile')} (${trans('optional').toLowerCase()})`">
          <b-form-input v-model="mobile" :disabled="busy" />
        </b-form-group>
        <b-form-group :label="`${trans('expiration')} (${trans('optional').toLowerCase()})`">
          <datetime v-model="expired_at" :config="dateOptions" :disabled="busy" />
        </b-form-group>
        <b-form-group :label="`${trans('max_view_count')} (${trans('optional').toLowerCase()})`">
          <b-form-input type="number" v-model="max_view_count" :disabled="busy" />
        </b-form-group>
      </b-col>
    </b-row>

    <p v-if="busy">
      <i class="fa fa-fw fa-circle-notch fa-spin"></i>
      {{ trans('please_wait') }}
    </p>
    <p v-if="error" class="text-danger">
      {{ error }}
    </p>

    <template v-slot:modal-footer>
      <b-row class="w-100">
        <b-col v-if="vimeo_url">
          <delete-button variant="outline-danger" @confirm="onDelete" :disabled="busy">
            {{ trans('delete') }}
          </delete-button>
        </b-col>
        <b-col class="text-right">
          <b-button variant="light" @click="$bvModal.hide('vimeo-url-modal')">
            {{ trans('cancel') }}
          </b-button>
          <b-button variant="primary" @click="onSave" :disabled="busy">
            {{ trans('save') }}
          </b-button>
        </b-col>
      </b-row>
    </template>
  </b-modal>
</template>

<script>
  import DeleteButton from './../../../common/components/DeleteConfirmButton'
  import Datetime from 'vue-bootstrap-datetimepicker'

  export default {
    props: {
      organization: Object,
      video: Object,
      vimeo_url: Object,
    },
    components: {
      DeleteButton,
      Datetime,
    },
    data() {
      return {
        trans: trans,
        busy: false,
        error: null,
        name: null,
        email: null,
        mobile: null,
        expired_at: null,
        dateOptions: {
          locale: window.lang,
          format: 'LL',
          showClear: true,
        },
        max_view_count: null,
      }
    },
    methods: {
      onSave() {
        this.busy = true
        this.error = null
        let url = `/organization/${this.organization.id}/media/vimeo/${this.video.id}/url`
        if (this.vimeo_url) url += `/${this.vimeo_url.id}`
        axios[this.vimeo_url ? 'patch' : 'post'](url, {
          name: this.name,
          email: this.email,
          mobile: this.mobile,
          expired_at: this.expired_at ? moment(this.expired_at, 'LL').toISOString() : null,
          max_view_count: this.max_view_count,
        })
        .then(response => {
          this.busy = false
          this.$emit('saved')
          this.$bvModal.hide('vimeo-url-modal')
        })
        .catch(error => {
          this.busy = false
          this.error = _.errorFromAjax(error)
        })
      },
      onDelete() {
        this.busy = true
        this.error = null
        let url = `/organization/${this.organization.id}/media/vimeo/${this.video.id}/url/${this.vimeo_url.id}`
        axios.delete(url)
        .then(response => {
          this.busy = false
          this.$emit('deleted')
          this.$bvModal.hide('vimeo-url-modal')
        })
        .catch(error => {
          this.busy = false
          this.error = _.errorFromAjax(error)
        })
      },
      onShow() {
        if (this.vimeo_url) {
          this.name = this.vimeo_url.name
          this.email = this.vimeo_url.email
          this.mobile = this.vimeo_url.mobile
          this.expired_at = this.vimeo_url.expired_at ? moment(this.vimeo_url.expired_at).format('LL') : null
          this.max_view_count = this.vimeo_url.max_view_count
        } else {
          this.name = null
          this.mobile = null
          this.expired_at = null
          this.max_view_count = null
        }
      },
    },
    mounted() {
      window.vimeoUrlModal = this
    },
  }
</script>